//
//
//
//
//
//
//

  export default{
    props: ['title'],
    data(){
      return {}
    },
    mounted(){

    },
    methods: {},
    components: {}

  }



// WEBPACK FOOTER //
// ./src/components/ItemHead.vue